export default "__VITE_ASSET__Dcgcyzc9__"